// extracted by mini-css-extract-plugin
export var buttonFadeInAnimation = "FullScreenPlayerCard-module--buttonFadeInAnimation--7084b";
export var card = "FullScreenPlayerCard-module--card--e9eb7";
export var content = "FullScreenPlayerCard-module--content--a7495";
export var expertWrapper = "FullScreenPlayerCard-module--expertWrapper--41967";
export var fadeInAnimation = "FullScreenPlayerCard-module--fadeInAnimation--7d208";
export var hideWhilePlaying = "FullScreenPlayerCard-module--hideWhilePlaying--ecf18";
export var leftSide = "FullScreenPlayerCard-module--leftSide--81b58";
export var name = "FullScreenPlayerCard-module--name--78a7d";
export var notActiveSlide = "FullScreenPlayerCard-module--notActiveSlide--c7e83";
export var playIcon = "FullScreenPlayerCard-module--playIcon--89f62";
export var playerButton = "FullScreenPlayerCard-module--playerButton--4c8af";
export var playerButtonIcon = "FullScreenPlayerCard-module--playerButtonIcon--1819f";
export var playerFloatingButton = "FullScreenPlayerCard-module--playerFloatingButton--56678";
export var playerHead = "FullScreenPlayerCard-module--playerHead--fbad5";
export var position = "FullScreenPlayerCard-module--position--2c61b";
export var progressBar = "FullScreenPlayerCard-module--progressBar--43f6f";
export var progressBarBackground = "FullScreenPlayerCard-module--progressBarBackground--a5510";
export var progressBarContainer = "FullScreenPlayerCard-module--progressBarContainer--dc822";
export var showControls = "FullScreenPlayerCard-module--showControls--f19be";
export var showOnDesktop = "FullScreenPlayerCard-module--showOnDesktop--1dd70";
export var showOnTablet = "FullScreenPlayerCard-module--showOnTablet--e45fe";
export var text = "FullScreenPlayerCard-module--text--491d2";
export var textWrapper = "FullScreenPlayerCard-module--textWrapper--84b05";
export var time = "FullScreenPlayerCard-module--time--7db68";
export var title = "FullScreenPlayerCard-module--title--d0a9a";
export var video = "FullScreenPlayerCard-module--video--17927";
export var videoControls = "FullScreenPlayerCard-module--videoControls--d589a";
export var videoLink = "FullScreenPlayerCard-module--videoLink--8c33b";
export var videoWrapper = "FullScreenPlayerCard-module--videoWrapper--a7da8";
export var volume = "FullScreenPlayerCard-module--volume--6a6a3";
export var volumeIcon = "FullScreenPlayerCard-module--volumeIcon--00d07";
export var volumeInput = "FullScreenPlayerCard-module--volumeInput--1944a";
export var volumeInputContainer = "FullScreenPlayerCard-module--volumeInputContainer--03b1a";